import { type GoatImageType, RewardPoints, SsuLogoPlaceholder } from '@capsicum/common';
import { type StaticImageData } from 'next/image';
import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Image } from '../../atoms/image/Image';

import { Goat } from './Goat';

export type PartnerGoatProps = PropsWithChildren<{
	assetType?: 'rp' | 'token';
	goatType: GoatImageType;
	partnerLogo?: StaticImageData | string;
	/**
	 * @deprecated use assetType instead
	 */
	partnerLogoDisplay?: boolean;
	title?: string;
	withoutTitleContainer?: boolean;
}>;

export const GoatWithPartner = ({
	assetType,
	children,
	goatType,
	partnerLogo,
	partnerLogoDisplay,
	title,
	withoutTitleContainer,
	...props
}: PartnerGoatProps) => {
	const hasPartnerLogo = assetType === 'token' || partnerLogoDisplay;
	const hasRpLogo = !partnerLogoDisplay && assetType === 'rp';

	return (
		<S.GoatContainer {...props}>
			<Goat
				image={goatType}
				testID="goat-with-partner-logo"
				title={title}
				withoutTitleContainer={withoutTitleContainer}
			>
				{children}
			</Goat>
			{hasPartnerLogo &&
				(partnerLogo ? (
					<S.FavTeam alt="currency-logo" height={60} src={partnerLogo} width={60} />
				) : (
					<S.FavTeam alt="currency-logo" height={60} src={SsuLogoPlaceholder} width={60} />
				))}
			{hasRpLogo && <S.RpLogo alt="currency-logo" height={45} src={RewardPoints} width={60} />}
		</S.GoatContainer>
	);
};

namespace S {
	export const GoatContainer = styled.div`
		position: relative;
		z-index: 1;
		width: 300px;
		height: 220px;
	`;

	export const FavTeam = styled(Image)`
		position: absolute;
		z-index: 2;
		top: 83px;
		left: 25px;
	`;

	export const RpLogo = styled(Image)`
		position: absolute;
		z-index: 2;
		top: 98px;
	`;
}
